import "./atoms-v2886.js";
import { isPrimaryPointer as t } from "./atoms-v2999.js";
function i(r) {
  return {
    point: {
      x: r.pageX,
      y: r.pageY
    }
  };
}
const a = (r) => (o) => t(o) && r(o, i(o));
export {
  a as addPointerInfo,
  i as extractEventInfo
};
